import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 17\" id=\"menu\">\n  <path fill-rule=\"evenodd\" d=\"M234,197h17v4H234v-4Zm0,6h17v4H234v-4Zm0,6h17v4H234v-4Z\" transform=\"translate(-233.5 -196.5)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/menu.svg
// module id = null
// module chunks = 